import React from 'react'
import { isMobile } from 'react-device-detect'
import { VStack, Box, Heading, Text, Button, CardGroup, Card } from 'rsuite'
import PeopleBranchIcon from '@rsuite/icons/PeopleBranch'
import AdvancedAnalyticsIcon from '@rsuite/icons/AdvancedAnalytics'
import ProjectIcon from '@rsuite/icons/Project'

import * as styles from './Homepage.m.css'

const Homepage: React.FC = (): React.ReactElement => {
  return (
    <VStack alignItems="center" spacing="1.5rem">
      <Box className={styles.hero}>
        <Heading className={styles.heading} level={1}>
          Turn your trade network into a revenue stream
        </Heading>
        <Text size="lg" mb="1.5rem">
          Engage your network for lead generation with flexible payout rules,
          secure tracking, and seamless partner management.
        </Text>
        <Button appearance="ghost" href="mailto:sales@techferral.com">
          Contact Sales
        </Button>
      </Box>
      <CardGroup columns={isMobile ? 1 : 3} spacing={21}>
        <Card>
          <Card.Header>
            <PeopleBranchIcon color="blue" size="2rem" />
          </Card.Header>
          <Card.Body>
            <Text weight="bold">Network Management</Text>
            <Text>
              Easily manage HVAC techs, electricians, and other trade partners
              with unique referral links.
            </Text>
          </Card.Body>
        </Card>
        <Card>
          <Card.Header>
            <AdvancedAnalyticsIcon color="green" size="2rem" />
          </Card.Header>
          <Card.Body>
            <Text weight="bold">Flexible Payout Rules</Text>
            <Text>Configure custom payout rules per partner or trade.</Text>
          </Card.Body>
        </Card>
        <Card>
          <Card.Header>
            <ProjectIcon color="purple" size="2rem" />
          </Card.Header>
          <Card.Body>
            <Text weight="bold">Unique Links</Text>
            <Text>
              Partners receive a unique trackable link to share with prospective
              customers.
            </Text>
          </Card.Body>
        </Card>
      </CardGroup>
    </VStack>
  )
}

export default Homepage
